module.exports = __webpack_public_path__ + "static/media/dat.799eab09.svg";